<template>
  <div>    
    <div class="TabellaOperazioniRicambi">
      <table   width="100%" border="0" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <th scope="col">Codice ricambio</th>
            <th scope="col">Descrizione ricambio</th>
            <th scope="col">Unità mis.</th>
            <th scope="col">Q.tà prevista</th>
            <th scope="col">Q.tà effettiva</th>
            <th scope="col">Incluso</th>
            <th scope="col">Magazzino</th>
          </tr>

          <RicambioRigaStorico
            v-for="ricambio in this.listaRicambi" 
            :key="ricambio.SysChiaveglobale"                 
            :ricambio="ricambio"
          >
          </RicambioRigaStorico>

        </tbody>
      </table>
    </div>
    
  </div>  
</template>

<script>
import RicambioAttivita from "@/models/ricambioAttivita.model.js";
import RicambioRigaStorico from "@/components/RicambioRigaStorico.vue"
import {apiMixin} from "/mixin.js";

export default {
    name: "GrigliaRicambi",
    data(){
        return {
            listaRicambi: []
        }
    },
    props: {
        attivita: Object,
        chiaveAttivita: String
    },
    components: {
        RicambioRigaStorico       
    },
    mixins: [apiMixin],   
    mounted(){
          let params = {
            GlbAttivita: this.chiaveAttivita
          };

          this.doApiCall("get", "interventi/GetRicambi", this.$store.getters.getUtente.Token, params).then(

            (data) => {                
              if(data){
                  this.listaRicambi = data.map(o => {
                      return Object.assign(new RicambioAttivita(), o)
                  });                                                  
              }             
            }
          );
    }    
}
</script>